// import { convertToOrderNumber } from '@/utils/common'

// status 참조: in/woowa/market/services/order/domain/OrderSummary.java:144
const OrderDetailSummaryStatus = Object.freeze({
  ORDERED: 'ORDERED',
  PAYMENTED: 'PAYMENTED',
  PAYMENT_FAILED: 'PAYMENT_FAILED',
  PRODUCT_PREPARATION: 'PRODUCT_PREPARATION',
  DELIVERING: 'DELIVERING',
  COMPLETED: 'COMPLETED',
  CANCELLED: 'CANCELLED'
})

const OrderDetailSummary = class {
  constructor({
    status,
    orderId,
    orderNumber,
    shopId,
    shopName,
    orderName,
    orderAmount,
    discountAmount,
    arriveDateTime,
    cancelReason,
    orderedDateTime,
    paymentAmount,
    isMember,
    deleted = false,
    baeminPayReceiptIssued = false,
    receiptButtonExposure = false
  }) {
    this.status = status
    this.orderId = orderId
    this.orderNumber = orderNumber
    this.shopId = shopId
    this.shopName = shopName
    this.orderName = orderName
    this.orderAmount = orderAmount
    this.discountAmount = discountAmount
    this.paymentAmount = paymentAmount
    this.arriveDateTime = arriveDateTime
    this.cancelReason = cancelReason
    this.orderedDateTime = !orderedDateTime ? '' : this.makeOrderedTime(orderedDateTime)
    this.isMember = isMember
    this.deleted = deleted
    this.baeminPayReceiptIssued = baeminPayReceiptIssued
    this.receiptButtonExposure = receiptButtonExposure
  }

  makeOrderedTime(time) {
    const splitDateAndTime = time.split(' ')
    const splitDate = splitDateAndTime[0].split('-')
    const splitTime = splitDateAndTime[1].split(':')

    const parseHour = parseInt(splitTime[0], 10)
    const hour =
      parseHour >= 12 ? `오후 ${parseHour === 12 ? 12 : parseHour - 12}` : `오전 ${parseHour}`

    const date = `${splitDate[0]}년 ${parseInt(splitDate[1], 10)}월 ${parseInt(
      splitDate[2],
      10
    )}일 ${hour}:${splitTime[1]}`

    return date
  }

  get convertedOrderId() {
    // return convertToOrderNumber(this.orderId)
    return this.orderId
  }

  isNotInProgress() {
    return [OrderDetailSummaryStatus.COMPLETED, OrderDetailSummaryStatus.CANCELLED].includes(
      this.status
    )
  }

  isBaeminPayReceiptIssued() {
    return this.baeminPayReceiptIssued
  }

  isReceiptButtonExposure() {
    return this.receiptButtonExposure
  }

  baeminPayReceiptIssuedText() {
    return '2020년 7월 7일 이전 배민페이(카드결제)로 결제한 건은 영수증을 발송할 수 없습니다. 영수증이 필요한 경우 배달의민족 고객센터로 문의 부탁드립니다.'
  }
}

export default null

export const ofOrderDetailSummary = (params = {}) => new OrderDetailSummary(params)
